import React from 'react';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import SummaryDetails from '../../../ssm-homepage/ssm-components/summary-details/summary-details';
import './instruction-steps.css';

const InstructionSteps = (props) => {
  const {
    heading,
    steps,
  } = props.steps;

  const stepsDisplay = () => {
    const stepsData = steps.map((step, index) => (
      <div
        key={`step-list-item-${index + 1}`}
        className={`${steps.length > 2 ? 'col-sm-12 col-md-4 step-list-item' : 'col-sm-12 col-md-6 step-list-item'}`}
      >
        <SvgIcon name={`icon-system-number-${index + 1}`} className="step-label-count custom-svg-class" />
        <div className="step-label-text">{step}</div>
      </div>
    ));
    return stepsData;
  };

  return (
    <div className="instruction-steps-section padding-top-bottom-24">
      <SummaryDetails
        summaryTitle={heading}
        customHeadingClass="heading34"
      />
      <div className="row steps-list">
        {stepsDisplay()}
      </div>
    </div>
  );
};

export default InstructionSteps;
